

function deliver(){
    var d = new Date();
    var weekday = new Array(7);
    weekday[0] = "Duminica";
    weekday[1] = "Luni";
    weekday[2] = "Marti";
    weekday[3] = "Miercuri";
    weekday[4] = "Joi";
    weekday[5] = "Vineri";
    weekday[6] = "Sambata";
    var month = new Array(12);
	month[0] = "Ianuarie";
    month[1] = "Februarie";
    month[2] = "Martie";
    month[3] = "Aprilie";
    month[4] = "Mai";
    month[5] = "Iunie";
    month[6] = "Iulie";
    month[7] = "August";
    month[8] = "Septembrie";
    month[9] = "Octombrie";
    month[10] = "Noiembrie";
    month[11] = "Decembrie";
    
    if(d.getDay()==0 || d.getDay()==6 || d.getDay()==5){
      
      if(d.getDay()==6){
        d.setDate(d.getDate() + 3);
        
     
      }else if(d.getDay()==5){
        d.setDate(d.getDate() + 4);
       
      }else{
        d.setDate(d.getDate() + 2);
      }
      var cd = d.getDay();
        var m = month[d.getMonth()];
        var n = weekday[cd]
        var cand = n+' '+d.getDate()+' '+m;
    }else{
      var cd=d.getDay();
      if(d.getHours()>=16){
      	cd = d.getDay()+2;
      }else{
        cd = d.getDay()+1;
      }
      
      var n = weekday[cd];
      var m = month[d.getMonth()];
      d.setDate(d.getDate() + 1);
      var cand = n+' '+d.getDate()+' '+m;
    }
  
    return cand;
  }

  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

  $(document).ready(function(){
    //console.log('Cookie1:'+getCookie('ct_impro_added_to_cart'));
    //console.log('Cookie2:'+getCookie('ct_impro_closed_notif'));
 
    if(getCookie('ct_impro_added_to_cart')==='1' && getCookie('ct_impro_closed_notif')==='0'){
      $('.ct_notif .notification').slideDown(300);
    }
    
    // estimare livrare produs impro
    if ($('#ct_estimare_livrare').length > 0) { 
      $('#ct_estimare_livrare').html(deliver());
    }
    
    // sticky add to cart topbar impro
    if($('.ct_top_bar_produs').length > 0){
      $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var objectSelect = $('#addToCart-product-template');
      var objectPosition = objectSelect.offset().top;

      if (scroll > objectPosition) {
        $('.ct_top_bar_produs').slideDown(300);
       
      } else {
        $('.ct_top_bar_produs').slideUp(300);
     
      }
    });
    }
    
    if($('.trigger_ct_discount').length > 0){
      $('.trigger_ct_discount').on('click',function(){
       	jQuery.getJSON('/cart.js', function(cart) {
          	
          	var cos_total = cart.total_price.toString().slice(0,-2);
          	var discount_total = cart.total_discount.toString().slice(0,-2);
          	var produse_total = cart.item_count+1;
          
          	 setCookie('ct_impro_added_to_cart','1',3);
          	 setCookie('ct_impro_closed_notif','0',3);
          
          	$('.notification-title span').text(cart.total_price.toString().slice(0,-2)*0.10 +' Lei');
          	
         	//console.log('Sunt ' + cart.item_count + ' produse in cos. Adica vei plati '+cos_total+' lei Andrei, ai economisit '+discount_total+' lei... ai bani de '+(discount_total/2)+' invitatii extra :D');
      	});
      
      });
    }
    
    
    if($('.ct_notif').length>0){
      $('.side-cart a.close').on('click',function(){
        jQuery.getJSON('/cart.js', function(cart) {
          	
          	var cos_total = cart.total_price.toString().slice(0,-2);
          	var discount_total = cart.total_discount.toString().slice(0,-2);
          	var produse_total = cart.item_count+1;
          
          	 setCookie('ct_impro_added_to_cart','1',3);
          	 setCookie('ct_impro_closed_notif','0',3);
          
          	$('.notification-title span').text(cart.total_price.toString().slice(0,-2)*0.10 +' Lei');
        });
                       
        $('.ct_notif .notification').slideDown(300);
        
      });
                                           
      $('.notification-close').on('click', notificationClose);
	  
      function notificationClose() {
        setCookie('ct_impro_closed_notif','1',3);
        $(this)
          .parent('.notification')
          .slideUp(300);
      };
    }
    
  });